import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    ChangeDetectorRef,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    FormControl,
    FormGroup,
    Validators,
    FormBuilder,
    FormArray,
    AbstractControl,
} from "@angular/forms";

import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { SatService } from "../../../../../../services/sat/sat.service";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { SharedCatalogService } from "../../../../../../services/shared/sharedcatalog.service";
import { ShortCode } from "../../../../../../utils/types/shared/shortcode.type";
import { GruposService } from "../../../../../../services/groups/grupos.service";
import { Grupo } from "../../../../../../utils/types/groups/grupo.type";

import { SatInstantDTO } from "../../../../../../utils/types/sat/satInstantDTO.type";
import {
    ContentSAT,
    SmsAction,
    BrowserAction,
    InputAction,
} from "../../../../../../utils/types/sat/contentSAT.type";
import { ShortCodesKeyword } from "../../../../../../utils/types/shared/shortcodeskeyword";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-sat-form",
    templateUrl: "./sat-form.component.html",
    styleUrls: ["./sat-form.component.scss"],
    providers: [
        SatService,
        AuthenticationService,
        SharedCatalogService,
        GruposService,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class SatFormComponent implements OnInit {
    satModel: SatInstantDTO;
    dialogTitle: string;
    action: RecordAction;
    callback: (sat) => void;
    isWaiting = false;

    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;

    itemsSAT: FormArray;
    contentsSAT: Array<ContentSAT>;

    shortCodes: ShortCode[];
    grupos: Grupo[];
    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    checkedRadioButton = new Array<number>();
    selectedKeyword = new Array<number>();
    selectedParaShortCode = new Array<number>();

    shortCodesKeywords: ShortCodesKeyword[];
    counter = 1;

    tabs = ["Sat-1"];
    selected = new FormControl(0);

    acciones = [
        { id: 1, name: "Sin Acciones" },
        { id: 2, name: "Enviar SMS" },
        { id: 3, name: "Abrir Navegador" },
        { id: 4, name: "SAT Input" },
    ];

    shortCodes_abanico = [{ id: 1, value: "9292" }];

    constructor(
        public dialogRef: MatDialogRef<SatFormComponent>,
        private ref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private gruposervice: GruposService,
        private sharedCatalog: SharedCatalogService,
        private _formBuilder: FormBuilder,
        private translateService: TranslateService,
        private satService: SatService,
        private authenticationService: AuthenticationService
    ) {
        this.satModel = data.sat;
        this.action = data.action;
        this.shortCodes = data.shortCodes;
        this.callback = data.callback;
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.checkedRadioButton.push(1);

        this.acciones.forEach((element) => {
            element.name = this.translateService.instant(element.name);
        });

        this.contentsSAT = new Array<ContentSAT>();

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = "Campaña SAT Instantanea";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);

            this.gruposervice
                .getGroupByOperator(this.satModel.shortCode.operator_id)
                .subscribe((res) => {
                    this.grupos = res;
                    this.firstFormGroup.controls["grupo"].setValue(
                        this.satModel.groups
                    );
                });
        } else {
            this.dialogTitle = "Campaña SAT Instantanea";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.satModel = new SatInstantDTO();
        }

        this.firstFormGroup = this._formBuilder.group({
            name: [this.satModel.name, Validators.required],
            istracking: [this.satModel.istracking],
            shortcode: [this.satModel.shortCode, Validators.required],
            grupo: [this.satModel.groups, Validators.required],
        });

        this.firstFormGroup.controls["name"].valueChanges.subscribe(
            (value) => (this.satModel.name = value)
        );

        this.firstFormGroup.controls["istracking"].valueChanges.subscribe(
            (value) => (this.satModel.istracking = value)
        );

        this.firstFormGroup.controls["shortcode"].valueChanges.subscribe(
            (value) => {
                this.satModel.shortCode = value;

                this.gruposervice
                    .getGroupByOperator(this.satModel.shortCode.operator_id)
                    .subscribe((res) => {
                        this.grupos = res;
                        this.firstFormGroup.controls["grupo"].setValue(
                            this.satModel.groups
                        );
                    });
            }
        );

        this.firstFormGroup.controls["grupo"].valueChanges.subscribe(
            (value) => {
                this.satModel.groups = value;
            }
        );

        this.secondFormGroup = this._formBuilder.group({
            items: this._formBuilder.array([this.createItemSAT()]),
        });

        this.itemsSAT = this.secondFormGroup.get("items") as FormArray;
        this.itemsSAT.at(0).get("message").setValidators(Validators.required);
    }

    createItemSAT(): FormGroup {
        return this._formBuilder.group({
            message: [""],
            para: [
                { value: "", disabled: this.action === this.recordAction.View },
            ],
            contenido: [
                { value: "", disabled: this.action === this.recordAction.View },
            ],
            textoamostrar: [""],
            url: [""],
            min: [""],
            max: [""],
            para2: [
                { value: "", disabled: this.action === this.recordAction.View },
            ],
        });
    }

    ngOnInit() {
        /*   this.sharedCatalog.gethortcodesAndKeyword().subscribe(res => {
            this.shortCodesKeywords = res;
        }); */

        if (this.action !== RecordAction.Add) {
            this.postValuesInArrayForm();
        }
    }

    compareFn(op1: any, op2: any) {
        return op1.id === op2.id;
    }

    performAction() {
        if (this.firstFormGroup.invalid || this.secondFormGroup.invalid) {
            return;
        }

        this.isWaiting = true;
        const arrayControl = this.secondFormGroup.get("items") as FormArray;

        for (let i = 0; i < arrayControl.controls.length; i++) {
            const itemSat = new ContentSAT();
            const control = arrayControl.at(i);

            if (control.invalid) {
                return;
            }

            itemSat.order = i + 1;
            itemSat.message = control.get("message").value;

            if (this.checkedRadioButton[i] === 2) {
                const smsAction = new SmsAction();
                smsAction.content = control.get("contenido").value;
                smsAction.to = control.get("para").value;
                itemSat.smsAction = smsAction;
            }

            if (this.checkedRadioButton[i] === 3) {
                const browserAction = new BrowserAction();
                browserAction.loadingText = control.get("textoamostrar").value;
                browserAction.url = control.get("url").value;
                itemSat.browserAction = browserAction;
            }

            if (this.checkedRadioButton[i] === 4) {
                const inputAction = new InputAction();
                inputAction.min = control.get("min").value;
                inputAction.max = control.get("max").value;
                inputAction.short_code = control.get("para2").value;
                itemSat.inputAction = inputAction;
            }

            this.contentsSAT.push(itemSat);
        }

        this.satModel.contents = this.contentsSAT;

        this.callback(this.satModel);
    }

    addTab() {
        this.counter = this.counter + 1;
        const name = "Sat-" + this.counter;
        this.tabs.push(name);

        this.checkedRadioButton.push(1);

        this.itemsSAT = this.secondFormGroup.get("items") as FormArray;
        this.itemsSAT.push(this.createItemSAT());
        this.ref.detectChanges();
        //  this.itemsSAT.at(this.tabs.length - 1).get('message');
        this.selected.setValue(this.tabs.length - 1);
    }

    removeTab(index: number) {
        this.itemsSAT = this.secondFormGroup.get("items") as FormArray;

        if (this.tabs.length !== 1) {
            this.tabs.splice(index, 1);
            this.itemsSAT.controls.splice(index, 1);
        }
    }

    radioChange(event: any, index: number) {
        const reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";
        const arrayControl = this.secondFormGroup.get("items") as FormArray;
        const control = arrayControl.at(index);

        switch (event.value) {
            case 4:
                control.get("max").setValidators(Validators.required);
                control.get("min").setValidators([Validators.required]);
                control.get("para2").setValidators([Validators.required]);
                this.ref.detectChanges();

                this.clearControlValidator(control, "contenido");
                this.clearControlValidator(control, "para");
                this.clearControlValidator(control, "textoamostrar");
                this.clearControlValidator(control, "url");
                this.ref.detectChanges();

                break;

            case 3:
                control.get("textoamostrar").setValidators(Validators.required);
                control.get("textoamostrar").updateValueAndValidity();
                control
                    .get("url")
                    .setValidators([
                        Validators.required,
                        Validators.pattern(reg),
                    ]);
                control.get("url").updateValueAndValidity();
                this.ref.detectChanges();
                this.clearControlValidator(control, "contenido");
                this.clearControlValidator(control, "para");
                this.clearControlValidator(control, "max");
                this.clearControlValidator(control, "min");
                this.clearControlValidator(control, "para2");
                this.ref.detectChanges();

                break;
            case 2:
                control.get("contenido").setValidators(Validators.required);
                control.get("para").setValidators(Validators.required);
                this.ref.detectChanges();

                this.clearControlValidator(control, "textoamostrar");
                this.clearControlValidator(control, "url");
                this.clearControlValidator(control, "max");
                this.clearControlValidator(control, "min");
                this.clearControlValidator(control, "para2");
                this.ref.detectChanges();

                break;
            default:
                this.clearControlValidator(control, "contenido");
                this.clearControlValidator(control, "para");
                this.clearControlValidator(control, "textoamostrar");
                this.clearControlValidator(control, "url");
                this.clearControlValidator(control, "max");
                this.clearControlValidator(control, "min");
                this.clearControlValidator(control, "para2");
                this.ref.detectChanges();

                break;
        }
    }

    clearControlValidator(control: AbstractControl, controlName: string) {
        control.get(controlName).clearValidators();
        control.get(controlName).updateValueAndValidity();
    }

    postValuesInArrayForm() {
        const arrayControl = this.secondFormGroup.get("items") as FormArray;
        this.satModel.contents = _.orderBy(
            this.satModel.contents,
            ["order"],
            ["asc"]
        );

        let formField: AbstractControl;

        for (let i = 0; i < this.satModel.contents.length; i++) {
            if (i >= 1) {
                this.addTab();
            }

            const control = arrayControl.at(i);

            formField = control.get("message");
            formField.setValue(this.satModel.contents[i].message);

            if (this.satModel.contents[i].smsAction) {
                this.checkedRadioButton[i] = 2;

                formField = control.get("contenido");
                formField.setValue(this.satModel.contents[i].smsAction.content);

                formField = control.get("para");
                formField.setValue(this.satModel.contents[i].smsAction.to);
            }

            if (this.satModel.contents[i].browserAction) {
                this.checkedRadioButton[i] = 3;

                formField = control.get("textoamostrar");
                formField.setValue(
                    this.satModel.contents[i].browserAction.loadingText
                );

                formField = control.get("url");
                formField.setValue(this.satModel.contents[i].browserAction.url);
            }

            if (this.satModel.contents[i].inputAction) {
                this.checkedRadioButton[i] = 4;

                formField = control.get("min");
                formField.setValue(this.satModel.contents[i].inputAction.min);

                formField = control.get("max");
                formField.setValue(this.satModel.contents[i].inputAction.max);

                formField = control.get("para2");
                formField.setValue(
                    this.satModel.contents[i].inputAction.short_code
                );
            }
        }
        this.selected.setValue(0);
    }
}
